/* eslint-disable react/prop-types */

import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import moment from "moment";
import _ from "lodash";

import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiBadgeDot from "components/SuiBadgeDot";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import Filter from "examples/Icons/Filter";

import config from "configs";
import { Page } from "api";

function PageList({ mode }) {
  const history = useHistory();
  const [tabsOrientation] = useState("horizontal");
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();

  const columns = [
    { Header: t("Page"), accessor: "name" },
    { Header: t("Slug"), accessor: "slug" },
    {
      Header: t("status"),
      accessor: "status",
      width: "7%",
      Cell: ({ value }) => {
        if (!value) return <></>;
        let color = "light";
        let status = "Draft";
        if (value === "3") {
          color = "success";
          status = "Published";
        } else if (value === "2") {
          color = "dark";
          status = "Scheduled";
        } else if (value === "4") {
          color = "error";
          status = "Suspended";
        }
        return (
          <SuiBox ml={-1.325}>
            <SuiBadgeDot size="xs" color={color} badgeContent={t(status)} />
          </SuiBox>
        );
      },
    },
    { Header: t("Published on"), accessor: "schedulePublishedDate" },
    { Header: t("Editted on"), accessor: "publishedDate" },
  ];

  const [rawData, setRawData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const tableData = useMemo(() => {
    const data = { columns, rows: [] };

    data.rows = [];
    _.get(rawData, "results", []).forEach((result) => {
      data.rows.push({
        id: result.id,
        name: result.titleSC,
        slug: result.slugSC,
        status: result.status,
        schedulePublishedDate: result.schedulePublishedDate
          ? moment(result.schedulePublishedDate).format("YYYY-MM-DD hh:mm:ss A")
          : "",
        publishedDate: result.publishedDate
          ? moment(result.publishedDate).format("YYYY-MM-DD hh:mm:ss A")
          : "",
        style: {
          cursor: 'pointer'
        },
      });
    });

    return data;
  }, [rawData]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const params = { page, pageSize: config.defaults.PAGE_SIZE };
        if (activeTab) {
          params.status = activeTab;
        }
        const rsp = await Page.getAll(params);
        const { data } = rsp;
        setRawData(data);
        const { total, pageSize } = data;
        setPageCount(Math.ceil(total / pageSize));
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    })();
  }, [page, activeTab]);

  return (
    <>
      <Helmet>
        <title>{t("Page")}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5} width="100%">
          <SuiBox width="100%">
            <Card>
              <SuiBox p={3} lineHeight={1}>
                <SuiBox display="flex" justifyContent="space-between" alignItems="center" pt={2}>
                  {mode !== "view" && (
                    <SuiButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        history.push(`/pages/new`);
                      }}
                    >
                      {t("New Page")}
                    </SuiButton>
                  )}
                  {mode === "view" && <span />}
                  <SuiBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="50%"
                  >
                    <SuiBox width="100%">
                      <AppBar position="static">
                        <Tabs
                          orientation={tabsOrientation}
                          value={activeTab}
                          onChange={(...args) => {
                            setActiveTab(args[1]);
                            setPage(1);
                          }}
                        >
                          <Tab style={{ padding: 10 }} label={t("All")} />
                          <Tab label={t("Draft")} />
                          {/* <Tab label={t("Scheduled")} /> */}
                          <Tab label={t("Published")} />
                          {/* <Tab label={t("Suspended")} /> */}
                        </Tabs>
                      </AppBar>
                    </SuiBox>
                  </SuiBox>
                  <SuiBox style={{ opacity: 0 }}>
                    <Filter size="12px" />
                  </SuiBox>
                </SuiBox>
              </SuiBox>

              {isLoading ? (
                <>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : (
                <DataTable
                  pageCount={pageCount}
                  table={tableData}
                  showTotalEntries={false}
                  entriesPerPage={false}
                  isSorted={false}
                  onRowClick={(row) => {
                    history.push(`/pages/edit/${row.original.id}`);
                  }}
                  onPageChange={setPage}
                  page={page}
                />
              )}
            </Card>
          </SuiBox>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default PageList;
